'use strict';

var _ = require('lodash');
var tooltipMarketTemplate = _.template(require('../templates/chart-sponsor-forecast-market-tooltip-template.html'));
var tooltipFlightTemplate = _.template(require('../templates/chart-sponsor-forecast-flight-leg-tooltip-template.html'));
var ChartSponsorForecastController = function ChartSponsorForecastController($scope, $filter, ScheduleChangeConstants, marketsDataProviderService, legsDataProviderService, flightLegDataProviderService, chartFormatter) {
  var isMarketMode = $scope.wizardMode === ScheduleChangeConstants.ENTITIES.MARKETS;
  var isLegMode = $scope.wizardMode === ScheduleChangeConstants.ENTITIES.LEGS;
  $scope.isFlightMode = $scope.wizardMode === ScheduleChangeConstants.ENTITIES.FLIGHTS;
  var defaultSelectionSize = -30;
  var rmNumberFormat = $filter('rmNumberFormat');
  var rmMomentFormat = $filter('rmMomentFormat');
  var dataProviderService = isMarketMode ? marketsDataProviderService : isLegMode ? legsDataProviderService : flightLegDataProviderService;
  var marketsMetricLabels = ['Bookings', 'Revenue'];
  var legsMetricLabels = ['Bookings', 'Revenue', 'Load Factor', 'Capacity'];
  var differentTimeLegend = ' for flight departure between ';
  var sameTimeLegend = ' for flight departure at ';
  $scope.metricLabels = isMarketMode ? marketsMetricLabels : legsMetricLabels;
  $scope.selectedMetric = $scope.metricLabels[0];
  $scope.legend = differentTimeLegend;
  $scope.minMaxTime = '00:00 and 23:59 ';
  $scope.initChart = function () {
    $scope.changeMetricHandler($scope.selectedMetric);
  };
  $scope.changeMetricHandler = function (metric) {
    $scope.selectedMetric = metric;
    if (isMarketMode || isLegMode) {
      dataProviderService.getData($scope.market, metric).then(function (data) {
        $scope.renderChart(data, defaultSelectionSize);
      });
    } else {
      if (!$scope.flight) {
        return;
      }
      buildLegend();
      dataProviderService.getData($scope.flight, $scope.market, metric).then(function (data) {
        $scope.renderChart(data, defaultSelectionSize);
      });
    }
  };
  $scope.chartFormatters = {
    xAxisTickFormatter: function xAxisTickFormatter(d, i) {
      var format = i % 4 === 0 ? 'DAY_MONTH_SHORT_NAME' : 'DAY_OF_MONTH';
      return rmMomentFormat(d, format);
    },
    yAxisTickFormatter: chartFormatter.humanReadable,
    tooltipFormatter: function tooltipFormatter(d) {
      if (isMarketMode || isLegMode) {
        return tooltipMarketTemplate({
          m1: rmNumberFormat(d.m1, 'NUMBER'),
          m1Label: $scope.selectedMetric,
          date: rmMomentFormat(d.d1, 'DATE_USER_SETTINGS')
        });
      } else {
        return tooltipFlightTemplate({
          m1: rmNumberFormat(d.m1, 'NUMBER'),
          m1Label: $scope.selectedMetric,
          date: rmMomentFormat(d.d1, 'DATE_USER_SETTINGS'),
          flightCarrierNumber: d.flightCarrierNumber
        });
      }
    }
  };
  $scope.viewportFormatters = {
    xAxisTickValues: function xAxisTickValues(array) {
      $scope.viewportFormatters.domainLength = array.length;
      return [array[0].d1, array[array.length - 1].d1];
    },
    xAxisTickFormatter: function xAxisTickFormatter(d, i) {
      if (i === 0) {
        return '-' + ($scope.viewportFormatters.domainLength - 1);
      } else {
        return 'Today';
      }
    }
  };
  var buildLegend = function buildLegend() {
    if ($scope.flight.minHourMinute === $scope.flight.maxHourMinute) {
      $scope.legend = sameTimeLegend;
      $scope.minMaxTime = $scope.flight.minHourMinute;
    } else {
      $scope.legend = differentTimeLegend;
      $scope.minMaxTime = $scope.flight.minHourMinute + ' and ' + $scope.flight.maxHourMinute;
    }
  };
};
ChartSponsorForecastController.$inject = ['$scope', '$filter', 'ScheduleChangeConstants', 'ChartSponsorForecastMarketDataProviderService', 'ChartSponsorForecastLegDataProviderService', 'ChartSponsorForecastFlightLegDataProviderService', 'FormatterService'];
module.exports = ChartSponsorForecastController;